import { render } from "./WarehousePage.vue?vue&type=template&id=0c31417d&scoped=true&ts=true"
import script from "./WarehousePage.vue?vue&type=script&lang=ts"
export * from "./WarehousePage.vue?vue&type=script&lang=ts"

import "./WarehousePage.vue?vue&type=style&index=0&id=0c31417d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c31417d"]])

export default __exports__